module.exports = __webpack_public_path__ + "img/product_express_active_mobile.16b52c45.png";